<template>
    <drop-down
        :should-close="shouldCloseDropdown"
        @closeDropdown="(val) => (this.shouldCloseDropdown = val)"
        @closeOtherDropDown="closeOtherDropDown"
    >
        <span
            v-if="!statusChanging"
            class="status run-status-span"
            slot="title"
            data-toggle="dropdown"
            :class="[
                `run-status-${run.runStatus.toLowerCase().replace(/\s+/g, '')}`,
                className,
                statuses.length ? '' : 'no-pointer'
            ]"
        >
            {{ (statuses.find(status => status.key === run.runStatus) || {}).value || run.runStatus }}
        </span>
        <span
            v-if="statusChanging"
            class="status loader-container"
        >
            <div class="run-status-loading-spinner" />
        </span>
        <ul
            class="dropdown-menu"
            v-if="!isReadOnlyUser && statuses.length"
        >
            <li
                v-for="(status, index) in statuses"
                :key="index"
            >
                <a @click.stop="handleChangeRunStatus(status.key)">
                    {{ status.value }}
                </a>
            </li>
        </ul>
    </drop-down>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { handleRequests, showErrorMessage } from '@/helpers';
import { RUN_STATUS_CONSTANTS } from '@/utils/constants';

export default {
    name: 'RunStatusButton',
    mixins: [GeneralMixin],
    props: {
        run: {
            type: Object,
            default: () => {}
        },
        className: {
            type: String,
            default: () => ''
        }
    },
    computed: {
        ...mapGetters({
            isReadOnlyUser: 'user/isReadOnlyUser'
        })
    },
    data() {
        return {
            statuses: Object.entries(RUN_STATUS_CONSTANTS).map(([key, value]) => ({ key, value })),
            shouldCloseDropdown: false,
            statusChanging: false
        };
    },
    methods: {
        closeOtherDropDown() {
            const dropdowns = document.querySelectorAll('.open');
            dropdowns.forEach((dropdown) => dropdown.classList.remove('open'));
        },
        async handleChangeRunStatus(newStatus) {
            this.shouldCloseDropdown = true;
            const { runId, runStatus, tripId } = this.run;
            if (runStatus !== newStatus) {
                const payload = {
                    method: 'post',
                    data: {
                        status: newStatus,
                        actionDate: moment()
                    }
                };

                this.statusChanging = true;
                this.$nextTick(() => {
                    this.shouldCloseDropdown = false;
                });

                try {
                    const api = `/api/runs/${runId}/status`;
                    await handleRequests(api, payload);

                    this.$notify({
                        message: `Run status was changed to ${newStatus}!`,
                        type: 'success'
                    });

                    this.$emit('statusUpdated', { runId, runStatus: newStatus, tripId });

                } catch(e) {
                    const message = 'Cannot change run status.';
                    showErrorMessage(this, message, e);
                }
                finally {
                    this.statusChanging = false;
                }
            } else {
                const message = 'Cannot change status to the same status';
                this.$notify({
                    message,
                    type: 'danger'
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.status {
    color: #fff !important;
    min-width: 90px;
    text-align: center;
    display: block;
    line-height: 31px;
    font-weight: 400;
    max-width: 90px;
    cursor: pointer;
}

::v-deep .dropdown-menu {
    li {
        cursor: pointer !important;
    }
}

.no-pointer {
    cursor: not-allowed !important;
}


@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.run-status-loading-spinner {
    border: 4px solid #eeeeee;
    border-radius: 50%;
    border-top: 4px solid #2b93ff;
    width: 20px;
    height: 20px;
    -webkit-animation: spin 1s linear infinite;
    animation: spin 1s linear infinite;
    justify-self: center;
    margin: 0px !important;
    padding: 0px !important;
}

.loader-container {
    position: relative;
    left: auto;
    height: 0;
    padding-bottom: 8px;
}
</style>
